import omit from 'lodash-es/omit'

function AccordionItem({ ref, ...props }) {
  const divProps = omit(props, [
    'accordionTitle',
    'filterKey',
    'filterSecondKey',
    'initOpen',
    'listType',
    'onClick',
    'onDelete',
    'qaName',
    'staticCount',
  ])

  return <div {...divProps} ref={ref} />
}

export default AccordionItem
